import React, { useContext, useState } from 'react';
import { WMEditableTitle, WMTooltip } from '@walkme/wm-ui';

import { AppTableContext } from '../../AppTableContext';
import { withSkeleton } from '../../helpers/withSkeleton';

import classes from './TitleCell.module.scss';
import { MAX_NOTIFICATION_TITLE_LENGTH } from '../../../EditNotification/EditNotificationHeader/EditNotificationTitle/EditNotificationTitle';
import { ROLES } from '@communication-center/data-objects';
import Restricted from '../../../../infrastructure/Permissions/Restricted';

const Title = ({ title, id, userId, isEditableTitle, onTitleEdit }: $TSFixMe) => {
    const { tableDataTestid } = useContext(AppTableContext);
    const [isTitleFocused, setIsTitleFocused] = useState(false);

    return (
        <WMTooltip title={isTitleFocused || !title ? '' : title}>
            <div className={classes.titleWrapper} data-testid={`${id}-title-${tableDataTestid}`} onClick={e => e.stopPropagation()}>
                {isEditableTitle && title ? (
                    <Restricted to={[ROLES.ADMIN]} creatorsIds={[userId]} emptyRenderer={<span>{title}</span>}>
                        <WMEditableTitle
                            maxLength={MAX_NOTIFICATION_TITLE_LENGTH}
                            classes={{ root: classes.wmEditableTitleRoot }}
                            value={title}
                            onApprove={onTitleEdit}
                            className={classes.editableTitle}
                            onEditStart={() => setIsTitleFocused(true)}
                            onEditEnd={() => setIsTitleFocused(false)}
                        />
                    </Restricted>
                ) : (
                    <span>{title}</span>
                )}
            </div>
        </WMTooltip>
    );
};

export default withSkeleton({ height: 14, width: 100, style: { marginBottom: '5px' } })(Title);
